module.exports = __webpack_public_path__ + "media/images/login-page-background-758586cc16ecc4776b3c7a722c326617.png";